import { __assign, __generator } from "tslib";
import { all, put, call, takeEvery } from 'redux-saga/effects';
import get from 'lodash/get';
import { Url, URLS, USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { convertToServerXhrPayload } from '../../DaEditorWrapper/utils';
import { request } from '../../xhr';
import { normalize } from '../../redux/normalizr';
import { putEntities } from '../../redux/entities/actions';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { editDeviationSuccess } from '../../redux/deviations/actionCreators';
import { logBiEvent } from '../../biLogger/redux/saga';
import { ResourceType } from '../../types/resource';
import { WriterPopupType } from './types';
import { publishWriterDeviation, saveWriterDeviation, saveWriterDeviationSuccess, saveWriterDeviationFailure, setIsRedirecting, } from './actions';
import { convertResponseErrorToWriterError, fakeResponse, getWriterEndpoint, } from './utils';
var logger = ddt.createLogger('writer.saga');
function dispatchSaveWriterDeviationFailure(response) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(saveWriterDeviationFailure(convertResponseErrorToWriterError(response === null || response === void 0 ? void 0 : response.errorDetails)))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function doCreateWriterDeviation(type, groupId, localState) {
    var _a, title, editorState, coverImage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = localState.journalTitle, title = _a === void 0 ? '' : _a, editorState = localState.editorState, coverImage = localState.coverImage;
                logger.log('doCreateWriterDeviation', { type: type, groupId: groupId, localState: localState });
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/create', type),
                        data: __assign({ title: title, group_id: groupId, cover_image_deviation_id: coverImage === null || coverImage === void 0 ? void 0 : coverImage.deviationId }, convertToServerXhrPayload(editorState === null || editorState === void 0 ? void 0 : editorState.rawContentState, editorState === null || editorState === void 0 ? void 0 : editorState.editorContent, editorState === null || editorState === void 0 ? void 0 : editorState.features)),
                    }, fakeResponse)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}
function doUpdateWriterDeviation(type, groupId, deviation, localState) {
    var _a, title, editorState, coverImage;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = localState.journalTitle, title = _a === void 0 ? '' : _a, editorState = localState.editorState, coverImage = localState.coverImage;
                logger.log('doUpdateWriterDeviation', {
                    type: type,
                    groupId: groupId,
                    deviation: deviation,
                    localState: localState,
                });
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/update/content', type),
                        data: __assign({ title: title, group_id: groupId, deviationid: deviation === null || deviation === void 0 ? void 0 : deviation.deviationId, cover_image_deviation_id: coverImage === null || coverImage === void 0 ? void 0 : coverImage.deviationId }, convertToServerXhrPayload(editorState === null || editorState === void 0 ? void 0 : editorState.rawContentState, editorState === null || editorState === void 0 ? void 0 : editorState.editorContent, editorState === null || editorState === void 0 ? void 0 : editorState.features)),
                    }, fakeResponse)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}
/** Sends a request to our create or update endpoint depending on if the provided deviation exists */
function doCreateOrUpdateDeviation(type, groupId, deviation, localState) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = null;
                if (!((deviation === null || deviation === void 0 ? void 0 : deviation.deviationId) === undefined)) return [3 /*break*/, 2];
                return [4 /*yield*/, call(doCreateWriterDeviation, type, groupId, localState)];
            case 1:
                result = _a.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, call(doUpdateWriterDeviation, type, groupId, deviation, localState)];
            case 3:
                result = _a.sent();
                _a.label = 4;
            case 4:
                if (!(result && (result === null || result === void 0 ? void 0 : result.deviation))) return [3 /*break*/, 6];
                return [4 /*yield*/, call(handleSuccess, { deviation: result === null || result === void 0 ? void 0 : result.deviation, type: type }, (deviation === null || deviation === void 0 ? void 0 : deviation.deviationId) !== undefined)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, call(dispatchSaveWriterDeviationFailure, result)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/, result];
        }
    });
}
function handleSuccess(_a, wasEdit) {
    var _b, deviationId, entities, resultActions;
    var deviation = _a.deviation, type = _a.type;
    if (wasEdit === void 0) { wasEdit = false; }
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = normalize(deviation, deviationSchema), deviationId = _b.result, entities = _b.entities;
                resultActions = [
                    put(putEntities({ entities: entities })),
                    // Even though deviationId is expected to be a number and we're passing through the normalized
                    // deviation id (which could be number | string), it should only ever receive
                    // a deviation that production an id of type number
                    put(saveWriterDeviationSuccess({ deviationId: deviationId, type: type })),
                ];
                if (wasEdit) {
                    resultActions.push(put(editDeviationSuccess({ deviation: deviation })));
                }
                return [4 /*yield*/, all(resultActions)];
            case 1:
                _c.sent();
                logger.log('success', deviationId);
                return [2 /*return*/];
        }
    });
}
function handleRedirect(url) {
    return __generator(this, function (_a) {
        logger.log('redirect', url);
        window.location.assign(url);
        return [2 /*return*/];
    });
}
function handleSaveWriterDeviation(action) {
    var _a, type, deviation, groupId, localState, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: 
            // need to call "setIsRedirecting" before "doCommonSaveResultCleanup" to have a smooth
            // transition from isSubmitting to isRedirecting
            return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: true }))];
            case 1:
                // need to call "setIsRedirecting" before "doCommonSaveResultCleanup" to have a smooth
                // transition from isSubmitting to isRedirecting
                _b.sent();
                _a = action.payload, type = _a.type, deviation = _a.deviation, groupId = _a.groupId, localState = _a.localState;
                return [4 /*yield*/, call(doCreateOrUpdateDeviation, type, groupId, deviation, localState)];
            case 2:
                result = _b.sent();
                if (!(result && result.deviation)) return [3 /*break*/, 6];
                if (!(type === WriterPopupType.LITERATURE)) return [3 /*break*/, 4];
                // Saving a Literature draft should redirect to the sta.sh draft folder
                // but since we do not know the drafts folder hash (yet to be implemented
                // on the backend) we should redirect to the sta.sh root
                return [4 /*yield*/, call(handleRedirect, "" + Url.buildFromPath(URLS.STASH))];
            case 3:
                // Saving a Literature draft should redirect to the sta.sh draft folder
                // but since we do not know the drafts folder hash (yet to be implemented
                // on the backend) we should redirect to the sta.sh root
                _b.sent();
                return [2 /*return*/];
            case 4: 
            // Upon successful submission, we should redirect to Posts/Drafts tab
            return [4 /*yield*/, call(handleRedirect, Url.userPostsLink({
                    username: (result.deviation.author && result.deviation.author.username) || '',
                    subPath: USER_PROFILE_POSTS_SUB_PATHS.DRAFTS,
                }))];
            case 5:
                // Upon successful submission, we should redirect to Posts/Drafts tab
                _b.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: false }))];
            case 7:
                _b.sent();
                _b.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function handlePublishWriterDeviation(action) {
    var _a, type, groupId, refreshAfterSubmit, deviation, localState, saveResult, deviationid, result, deviation_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, type = _a.type, groupId = _a.groupId, refreshAfterSubmit = _a.refreshAfterSubmit, deviation = _a.deviation, localState = _a.localState;
                logger.log('publishWriterDeviation', action.payload);
                // need to call "setIsRedirecting" before any save/publish requests to have a smooth
                // transition from isSubmitting to isRedirecting
                return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: true }))];
            case 1:
                // need to call "setIsRedirecting" before any save/publish requests to have a smooth
                // transition from isSubmitting to isRedirecting
                _b.sent();
                return [4 /*yield*/, call(doCreateOrUpdateDeviation, type, groupId, deviation, localState)];
            case 2:
                saveResult = _b.sent();
                if (!(!saveResult || !saveResult.deviation)) return [3 /*break*/, 4];
                if (saveResult && saveResult.errorCode === 302) {
                    window.location.replace(saveResult.errorDetails.redirectUrl);
                }
                return [4 /*yield*/, call(dispatchSaveWriterDeviationFailure, saveResult)];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4:
                deviationid = get(saveResult.deviation, 'deviationId', null);
                if (!(type === WriterPopupType.LITERATURE)) return [3 /*break*/, 8];
                if (!!(deviation === null || deviation === void 0 ? void 0 : deviation.isPublished)) return [3 /*break*/, 6];
                return [4 /*yield*/, call(logBiEvent, {
                        evid: BiEventType.SUBMIT_CONTENT,
                        group_exclusive: groupId !== undefined,
                        typeid: ResourceType.DEVIATION,
                        itemid: deviationid,
                    })];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [4 /*yield*/, call(handleRedirect, Url.buildFromPath(URLS.SUBMIT) + "?deviationids=" + deviationid)];
            case 7:
                _b.sent();
                return [2 /*return*/];
            case 8: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: getWriterEndpoint('/publish', type),
                    data: {
                        deviationid: deviationid,
                        featured: localState.isFeaturedPost,
                        group_id: groupId,
                    },
                }, fakeResponse)];
            case 9:
                result = _b.sent();
                logger.log('response', result);
                if (!(result && result.deviation)) return [3 /*break*/, 16];
                deviation_1 = result.deviation;
                if (!!(deviation_1 === null || deviation_1 === void 0 ? void 0 : deviation_1.isPublished)) return [3 /*break*/, 11];
                return [4 /*yield*/, call(logBiEvent, {
                        evid: BiEventType.SUBMIT_CONTENT,
                        group_exclusive: groupId !== undefined,
                        typeid: ResourceType.JOURNAL,
                        itemid: result.deviation.deviationId,
                    })];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [4 /*yield*/, call(handleSuccess, { deviation: deviation_1, type: type })];
            case 12:
                _b.sent();
                if (!refreshAfterSubmit) return [3 /*break*/, 13];
                window.location.reload();
                return [3 /*break*/, 15];
            case 13: return [4 /*yield*/, call(handleRedirect, getDeviationUrl(deviation_1))];
            case 14:
                _b.sent();
                _b.label = 15;
            case 15: return [3 /*break*/, 19];
            case 16: return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: false }))];
            case 17:
                _b.sent();
                return [4 /*yield*/, call(dispatchSaveWriterDeviationFailure, result)];
            case 18:
                _b.sent();
                _b.label = 19;
            case 19: return [2 /*return*/];
        }
    });
}
function handleSaveWriterDeviationFailure(action) {
    return __generator(this, function (_a) {
        logger.log('failure', action.payload.error);
        return [2 /*return*/];
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(saveWriterDeviation, handleSaveWriterDeviation),
                    takeEvery(publishWriterDeviation, handlePublishWriterDeviation),
                    takeEvery(saveWriterDeviationFailure, handleSaveWriterDeviationFailure),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map